export const en = {
  wifi: {
    signIn: 'Sign in',
    setParameters: 'Set parameters',
    welcomeGuest: 'Welcome Guest!',
    welcomeUser: `Welcome {{name}}!`,
    youAreNowConnected: 'You are now connected',
    pleaseSignIn: 'Please sign in to access the internet.',
    welcomeAbroad: 'Ahoy, Captain',
    wifiAdventure:
      'Soon you`ll be surfing the mighty web waves like a seasoned captain. No digital sharks in sight - just smooth sailing ahead!',
    waitingForWifi: 'We`re configuring the connection ...',
    wifiPortal: 'Wifi portal',
    langEn: 'English',
    langAr: 'Arabic',
    wifiTestConfig: 'Wifi test config (only for development)',
    goToLoginPage: 'Go to login page with parameters',
    authSignInError:
      'Error while signing in to the wifi network, user not authorized, try again or contact support',
    authSignInSuccess: 'Successfully signed in',
    wifiTestConfigEnterGuestMAC: 'Enter guest MAC (required)',
    wifiTestConfigEnterAPMAC: 'Enter AP MAC',
    wifiTestConfigEnterSSID: 'Enter SSID',
    wifiTestConfigEnterTimeInMinutes: 'Enter time in minutes',
    sitesDashboardTitle: 'Sites dashboard',
    sitesDashboardTotalSites: 'Total sites',
    sitesDashboardWithLogo: 'With logo',
    sitesDashboardWithoutLogo: 'Without Logo',
    sitesDashboardLaunched: 'Launched',
    sitesDashboardNotLaunched: 'Not launched',
    sitesDashboardSearchPlaceholder: 'Search sites',
    sitesDashboardFilterAll: 'All Sites',
    sitesDashboardFilterLaunched: 'Launched',
    sitesDashboardFilterNotLaunched: 'Not Launched',
    sitesDashboardFilterWithLogo: 'With logo',
    sitesDashboardTableLogo: 'Logo',
    sitesDashboardTableCode: 'Site code',
    sitesDashboardTableDescription: 'Description',
    sitesDashboardTableAccessPoints: 'Access points',
    sitesDashboardTableStatus: 'Status',
    sitesDashboardNoResults: 'No sites found matching your search criteria.',
    sitesDashboardLoginRequired: 'Please sign in to access the Sites Dashboard.',
    customFields: {
      name: {
        label: 'Full Name',
        placeholder: 'Enter your full name',
        errorMessages: {
          required: 'Name is required for delivery',
          minLength: 'Name must be at least 2 characters',
        },
      },
      communicationEmail: {
        label: 'Email for updates',
        placeholder: 'example@email.com',
      },
    },
    profileLoadError: 'Failed to load profile',
    profileUpdateError: 'Failed to update profile',
  },
};
